import { makeStyles } from '@material-ui/core/styles';
import { buttonAddStyles, buttonDeleteStyles } from 'shared/Buttons/button.styles';

export const useListAnalyticsReportsStyles = makeStyles(theme => ({
  reports: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  buttonAdd: {
    ...buttonAddStyles
  },
  buttonDelete: {
    ...buttonDeleteStyles
  },
  modal: {
    '& .MuiDialog-paperWidthMd': {
      minWidth: '35rem'
    }
  }
}));
